import * as React from 'react';
import { Avatar, DateTime, Tooltip } from '../';
import BaseList from '../BaseList/BaseList';

class UserList extends BaseList {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.users.search,
      search: BaseList.search.users,
      path: 'settings/users',
      name: 'users',
    });
  }

  renderLeft(item) {
    return <Avatar email={item.email} />;
  }

  renderHead(item) {
    return <strong>{item.name || 'Pending User'}</strong>;
  }

  renderBody(item) {
    if (!this.props.showEmail) {
      return null;
    }

    const warning = (
      <span className="is-pulled-right tag is-danger">
        <Tooltip text="Email address not confirmed">Unconfirmed</Tooltip>
      </span>
    );

    return (
      <span>
        {!item.active ? warning : null}
        <br />
        {item.email}
      </span>
    );
  }

  renderFoot(item) {
    if (!this.props.showJoinDate) {
      return null;
    }
    return (
      <small>
        <br />
        Registered <DateTime date={item.created_at} />
      </small>
    );
  }
}

export default UserList;
